import keyMirror from 'keymirror'

export default keyMirror({
    ASC: null,
    DESC: null,
})
